import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "services",
  "data-aos": "fade-up"
}
const _hoisted_2 = {
  class: "container py-5",
  style: {"min-height":"500px"}
}
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-verydarkblue font-weight-bold mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block border-bottom border-9 w-30 w-md-10 border-color1 mb-3" }, null, -1)
const _hoisted_6 = { "data-aos": "fade-up" }
const _hoisted_7 = { class: "text-body-1 text-center" }
const _hoisted_8 = { class: "text-body-2 text-center" }
const _hoisted_9 = {
  key: 0,
  class: "col-12 col-md-4 my-4",
  "data-aos": "fade-up"
}

import { onMounted } from 'vue';
import { useConfigStore, useGlobalStore } from '@/stores';
import logoImage from '@/assets/logo.png';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'AlbumsList',
  setup(__props) {

const configStore = useConfigStore();
const globalStore = useGlobalStore();

onMounted(() => {
  globalStore.fetchAlbums(undefined);
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('ALBUMS_LIST')), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).albums, (album, index) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                key: index,
                cols: "12",
                md: "4",
                onClick: 
              () => {
                _ctx.$router.push({ name: 'albumPage', params: { id: album.id as number | string } });
              }
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "service-card",
                    height: "350"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: album.coverImage ?? _unref(logoImage),
                            contain: "",
                            height: "250",
                            class: "w-100"
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_7, [
                            _createElementVNode("b", null, _toDisplayString(_unref(configStore).stringLang(album.titleAr, album.titleEn)), 1)
                          ]),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(configStore).stringLang(
                      album.descriptionAr,
                      album.descriptionEn
                    )), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      (_unref(globalStore).projects.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('COMING_SOON')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})